import { request } from './http-client'
import { TParams } from './types'
import { ISingleOrder } from './types/orders'

const orderService = {
  getList: (id: string, params: TParams, headers?: Record<any, any>) =>
    request.get<{ orders: ISingleOrder[]; count: number | string }>(
      `/v2/customers/${id}/orders`,
      {
        params,
        headers,
      }
    ),
  getById: (id: string, config?: any) =>
    request.get<ISingleOrder>('/v2/order/' + id, config),
  create: (data: any) => request.post('/v2/ondemand-order', data),
  cancelOrder: (id: string, config?: any) =>
    request.patch('/v2/order/' + id + '/cancel-order', {}, config),

  changePaymentStatus: (orderId: string) =>
    request.patch(`/v1/order/${orderId}/change-payment-status`, {
      paid: true,
    }),

  update: (id: string, data: any) => request.put('/v1/customers/' + id, data),
  getActiveCount: (params?: any) =>
    request.get('/v1/customers/active-orders-count', { params }),
  getTracking: (params?: any) =>
    request.get('/v1/tracking/courier-last-location', { params }),
}

export default orderService
